"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _userflow = require("../../utils/userflow");

var _Button = _interopRequireDefault(require("../Button"));

var _easing = _interopRequireDefault(require("../ScrollCarousel/easing"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Slider = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Slider, _React$PureComponent);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Slider);
    _this = _super.call(this, props);
    _this.state = {
      slide: 0,
      slidesCount: 0,
      scrollable: false,
      hideControl: 'prev'
    }; // In case of SSR this shoud be placed in componentDidMount w/ rerender

    _this.events = (0, _userflow.makeTouchDependableEvents)();
    _this.onArrowClick = _this.onArrowClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDotClick = _this.onDotClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.syncScroll = _this.syncScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.sliderRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var dots = this.props.dots;

      var rendered = function rendered() {
        if (!dots && !_this2.sliderRef.current) {
          return null;
        }

        var _this2$sliderRef$curr = _this2.sliderRef.current,
            clientWidth = _this2$sliderRef$curr.clientWidth,
            scrollWidth = _this2$sliderRef$curr.scrollWidth;

        if (scrollWidth > clientWidth) {
          _this2.checkScrollAbility();
        }

        window.requestAnimationFrame(rendered);
        return null;
      };

      rendered();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevChildren = _ref.children;
      var children = this.props.children;

      if (prevChildren !== children) {
        this.checkScrollAbility();
      }
    }
  }, {
    key: "onArrowClick",
    value: function onArrowClick(e) {
      var _this3 = this;

      (0, _userflow.unlessLocked)(this, e, function () {
        var direction = e.currentTarget.dataset.direction;
        var width = _this3.sliderRef.current.clientWidth * direction;

        _this3.diffScroll(width, true);
      });
    }
  }, {
    key: "onDotClick",
    value: function onDotClick(e) {
      var _this4 = this;

      (0, _userflow.unlessLocked)(this, e, function () {
        var index = e.currentTarget.dataset.index;

        _this4.scrollToSlide(index);
      });
    }
  }, {
    key: "checkScrollAbility",
    value: function checkScrollAbility() {
      var _this$sliderRef$curre = this.sliderRef.current,
          clientWidth = _this$sliderRef$curre.clientWidth,
          scrollWidth = _this$sliderRef$curre.scrollWidth;
      return this.setState({
        slidesCount: Math.ceil(scrollWidth / clientWidth),
        scrollable: scrollWidth > clientWidth
      });
    }
  }, {
    key: "scrollToSlide",
    value: function scrollToSlide(index) {
      var _this$sliderRef$curre2 = this.sliderRef.current,
          scrollLeft = _this$sliderRef$curre2.scrollLeft,
          clientWidth = _this$sliderRef$curre2.clientWidth;
      var nextSlideOffset = clientWidth * Number(index);
      var diff = nextSlideOffset - scrollLeft;
      this.diffScroll(diff, true);
    }
  }, {
    key: "syncDot",
    value: function syncDot(node) {
      var offsetWidth = node.offsetWidth,
          scrollLeft = node.scrollLeft;
      var slide = Math.ceil(scrollLeft / offsetWidth);
      this.setState({
        slide: slide
      });
    }
  }, {
    key: "syncControlsVisibility",
    value: function syncControlsVisibility(node) {
      var hideControl = null;
      var offsetWidth = node.offsetWidth,
          scrollLeft = node.scrollLeft,
          scrollWidth = node.scrollWidth;
      var isEnd = scrollWidth - (scrollLeft + offsetWidth) === 0;

      if (scrollLeft <= 0) {
        hideControl = 'prev';
      } else if (isEnd) {
        hideControl = 'next';
      }

      this.setState({
        hideControl: hideControl
      });
    }
  }, {
    key: "diffScroll",
    value: function diffScroll(diff) {
      var _this5 = this;

      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var scrollable = this.sliderRef.current;
      var _this$props = this.props,
          duration = _this$props.duration,
          easing = _this$props.easing;
      var scrollLeft = scrollable.scrollLeft;

      if (animate) {
        this.animate(duration, easing, diff, function (d) {
          scrollable.scrollLeft += Math.floor(d);
        }, function () {
          scrollable.scrollLeft = scrollLeft + diff;

          _this5.syncScroll();
        });
      } else {
        scrollable.scrollLeft += diff;
        this.syncScroll();
      }
    }
  }, {
    key: "animate",
    value: function animate(duration, easing, value, clb, endClb) {
      _easing["default"].ease({
        easing: easing,
        duration: duration,
        length: value,
        animate: clb.bind(this),
        end: endClb instanceof Function ? endClb.bind(this) : null
      });
    } // EVENT HANDLERS

  }, {
    key: "syncScroll",
    value: function syncScroll(ev) {
      var node = ev && ev.currentTarget || this.sliderRef.current;
      this.syncDot(node);
      this.syncControlsVisibility(node);
    } // RENDERS

  }, {
    key: "renderControls",
    value: function renderControls() {
      var hideControl = this.state.hideControl;
      var attrs = (0, _defineProperty2["default"])({}, this.events.get('click'), this.onArrowClick);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hideControl !== 'prev' && /*#__PURE__*/_react["default"].createElement(StyledControlsButton, (0, _extends2["default"])({}, attrs, {
        "data-direction": -1
      })), hideControl !== 'next' && /*#__PURE__*/_react["default"].createElement(StyledControlsButton, (0, _extends2["default"])({}, attrs, {
        "data-direction": 1
      })));
    }
  }, {
    key: "renderSlides",
    value: function renderSlides() {
      var _this$props2 = this.props,
          gap = _this$props2.gap,
          offset = _this$props2.offset,
          children = _this$props2.children;

      var count = _react["default"].Children.count(children);

      var handleScroll = (0, _defineProperty2["default"])({}, this.events.get('wheel'), this.syncScroll);
      return /*#__PURE__*/_react["default"].createElement(Slides, {
        ref: this.sliderRef,
        offset: offset,
        handleScroll: handleScroll
      }, _react["default"].Children.map(children, function (child, i) {
        var margin = Slider.getImageGap(i, count, gap);
        return child && /*#__PURE__*/_react["default"].cloneElement(child, {
          style: _objectSpread({}, margin)
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function renderDots() {
      var _this6 = this;

      var _this$state = this.state,
          slide = _this$state.slide,
          slidesCount = _this$state.slidesCount;
      return /*#__PURE__*/_react["default"].createElement(StyledDots, null, Array.from(Array(slidesCount).keys()).map(function (index) {
        return /*#__PURE__*/_react["default"].createElement(StyledDot, {
          key: index,
          functional: true,
          active: index === slide,
          "data-index": index,
          onClick: _this6.onDotClick
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          dots = _this$props3.dots,
          controls = _this$props3.controls,
          overlay = _this$props3.overlay;
      var scrollable = this.state.scrollable;
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
        ref: this.containerRef,
        className: className
      }, /*#__PURE__*/_react["default"].createElement(StyledSlidesWrapper, null, controls && scrollable && this.renderControls(), this.renderSlides(), overlay && /*#__PURE__*/_react["default"].createElement(StyledOverlay, null)), dots && scrollable && this.renderDots());
    }
  }], [{
    key: "getImageGap",
    value: function getImageGap(i, count, gap) {
      if (i === count - 1) {
        return {
          marginRight: 0
        };
      }

      return {
        marginRight: gap
      };
    }
  }]);
  return Slider;
}(_react["default"].PureComponent);

Slider.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  controls: _propTypes["default"].bool,
  dots: _propTypes["default"].bool,
  duration: _propTypes["default"].number,
  easing: _propTypes["default"].string,
  gap: _propTypes["default"].number,
  offset: _propTypes["default"].number,
  overlay: _propTypes["default"].bool
};
Slider.defaultProps = {
  className: '',
  controls: true,
  dots: false,
  duration: 400,
  easing: 'linear',
  gap: 10,
  offset: 0,
  overlay: false
};

var Slides = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var offset = props.offset,
      handleScroll = props.handleScroll,
      children = props.children;
  return /*#__PURE__*/_react["default"].createElement(StyledSlidesScrollable, (0, _extends2["default"])({}, handleScroll, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(StyledSlidesList, {
    offset: offset
  }, children));
}), function (prevProps, nextProps) {
  return prevProps.children === nextProps.children;
});

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledContainer",
  componentId: "sc-xqmhe6-0"
})(["z-index:1;width:100%;height:auto;overflow:hidden;user-select:none;position:relative;padding-bottom:2px;"]);

var StyledSlidesWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledSlidesWrapper",
  componentId: "sc-xqmhe6-1"
})(["text-align:center;position:relative;"]);

var StyledOverlay = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledOverlay",
  componentId: "sc-xqmhe6-2"
})(["background:rgba(0,0,0,.2);height:100%;left:0;position:absolute;top:0;z-index:1;"]);

var StyledSlidesScrollable = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledSlidesScrollable",
  componentId: "sc-xqmhe6-3"
})(["overflow-x:auto;overflow-y:hidden;scrollbar-width:none;transform:translate3d(0,0,0);::-webkit-scrollbar{display:none;}"]);

var StyledSlidesList = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledSlidesList",
  componentId: "sc-xqmhe6-4"
})(["height:100%;display:flex;position:relative;width:fit-content;text-align:left;justify-content:flex-start;padding:0 ", "px;"], function (props) {
  return props.offset;
}); // controls


var StyledControlsButton = _styledComponents["default"].button.withConfig({
  displayName: "Slider__StyledControlsButton",
  componentId: "sc-xqmhe6-5"
})(["background-color:rgba(255,255,255,0);background-image:linear-gradient(to left,#f3f3f3,rgba(255,255,255,0));border:none;cursor:pointer;height:100%;outline:none;position:absolute;right:0;top:0;width:65px;z-index:2;&:before{opacity:0;height:20px;margin-left:17px;right:50%;content:'';width:20px;top:50%;display:block;cursor:pointer;border-width:3px 3px 0 0;border-style:solid;border-color:#fafafa;transform:rotate(45deg);}:hover{background:#0003;:before{opacity:1;}}", ";"], function (props) {
  return "\n    ".concat(props['data-direction'] < 0 ? "\n      left: 0;\n      transform: rotate(180deg);\n    " : "\n      right: 0;\n    ", ";\n  ");
}); // Dots


var StyledDots = _styledComponents["default"].div.withConfig({
  displayName: "Slider__StyledDots",
  componentId: "sc-xqmhe6-6"
})(["padding:17px 0 0;text-align:center;width:100%;"]);

var StyledDot = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Slider__StyledDot",
  componentId: "sc-xqmhe6-7"
})(["cursor:pointer;height:8px;outline:none;position:relative;width:28px;:before{background-color:", ";border:solid 1px;border-color:", ";border-radius:8px;box-sizing:border-box;content:'';height:8px;left:0;margin-left:auto;margin-right:auto;position:absolute;right:0;top:0;transition:all 0.1s ease-in-out;width:8px;}", ""], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.frenchGray;
}, function (props) {
  return props.active && "\n    :before { padding: 0 13px; }\n  ";
});
var _default = Slider;
exports["default"] = _default;